export default __webpack_public_path__ + "static/media/mobile.ba2c4bed.svg";